export default __webpack_public_path__ + "static/media/05-3D-(3-2).bfd6eb4a.jpg";